import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import ChatWootWidget from "./ChatWoot";

const WHATSAPP_PHONE = "4188210296";

function getDeviceLink() {
  if (typeof navigator === "undefined") {
    return `https://web.whatsapp.com/send?phone=${WHATSAPP_PHONE}`;
  }

  const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
    navigator.userAgent,
  );

  return isMobile
    ? `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}`
    : `https://web.whatsapp.com/send?phone=${WHATSAPP_PHONE}`;
}

export function SupportButton() {
  const auth = useSelector((state) => state.auth);
  const flags = auth?.feature_flags;

  const isChatWoot = !!auth?.authToken && !!flags?.chat_woot_widget;

  const href = useMemo(() => getDeviceLink(), []);

  if (isChatWoot) {
    return <ChatWootWidget empresa={auth?.user?.empresa} />;
  }

  return (
    <a
      href={href}
      className="whatsapp-float"
      target="_blank"
      rel="noreferrer"
      data-toggle="tooltip"
      data-placement="top"
      title="Canal oficial do atendimento Cashbarber"
    >
      <i className="fab fa-whatsapp whatsapp-float-icon" />
    </a>
  );
}

export default SupportButton;
